<div class="ts-console" [class.dark]="isDark">
  <ngx-loading [show]="isLoading"></ngx-loading>

  <!-- ══════════════════════════════════════════════════════════════════════════
       CONSOLE HEADER - Gaming Style HUD
  ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="ts-header">
    <div class="container-fluid">
      <div class="row align-items-center g-3">
        
        <!-- Left: Console Branding -->
        <div class="col-12 col-md-6 col-lg-4">
          <div class="ts-console-brand">
            <div class="ts-power-led"></div>
            <div class="ts-brand-content">
              <fa-icon [icon]="faGamepad" class="ts-brand-icon"></fa-icon>
              <div class="ts-brand-text">
                <span class="ts-brand-label">ADMIN CONSOLE</span>
                <span class="ts-brand-title">{{ 'TEAMS_STATISTICS.TITLE' | translate }}</span>
              </div>
            </div>
            <div class="ts-status-indicators">
              <span class="ts-led ts-led--green"></span>
              <span class="ts-led ts-led--yellow"></span>
              <span class="ts-led ts-led--red"></span>
            </div>
          </div>
        </div>

        <!-- Right: Stats Counter (if team selected) -->
        <div class="col-12 col-md-6 col-lg-8" *ngIf="team">
          <div class="ts-stats-hud">
            <div class="ts-stat-card">
              <fa-icon [icon]="faUsers" class="ts-stat-icon"></fa-icon>
              <div class="ts-stat-content">
                <span class="ts-stat-label">TEAM SELECTED</span>
                <span class="ts-stat-value">{{ team?.name || 'N/A' }}</span>
              </div>
            </div>
            <div class="ts-stat-card">
              <fa-icon [icon]="faTrophy" class="ts-stat-icon"></fa-icon>
              <div class="ts-stat-content">
                <span class="ts-stat-label">STATUS</span>
                <span class="ts-stat-value">ACTIVE</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
       CONTROL PANEL - Team Selection
  ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="ts-control-panel">
    <div class="container-fluid">
      
      <!-- Panel Header -->
      <div class="ts-panel-header">
        <div class="ts-panel-leds">
          <span class="ts-panel-led ts-panel-led--green"></span>
          <span class="ts-panel-led ts-panel-led--yellow"></span>
          <span class="ts-panel-led ts-panel-led--red"></span>
        </div>
        <span class="ts-panel-title">TEAM SELECTOR</span>
        <div class="ts-panel-line"></div>
      </div>

      <!-- Selection Controls -->
      <div class="row g-3 align-items-center">
        
        <!-- Team Icon -->
        <div class="col-auto" *ngIf="team?.icon">
          <div class="ts-team-avatar">
            <div class="ts-avatar-glow"></div>
            <app-s3-image [image]="team?.icon"></app-s3-image>
          </div>
        </div>

        <!-- Team Dropdown -->
        <div class="col-12 col-sm-6 col-lg-5">
          <div class="ts-input-console">
            <div class="ts-input-screen">
              <app-team-input-autocomplete
                [allOptionValue]="{ id: 'all-teams' }"
                [allOptionTitle]="'TEAMS_STATISTICS.ALL_TEAMS_TITLE'"
                (selectionChange)="onSelectTeam($event)"
                (teamsLoad)="isLoading = false"
              >
              </app-team-input-autocomplete>
            </div>
          </div>
        </div>

        <!-- Team Lead -->
        <div class="col-12 col-sm-6 col-lg-5" *ngIf="team?.teamLead">
          <div class="ts-lead-card">
            <div class="ts-lead-label">
              <mat-icon>person</mat-icon>
              <span>TEAM LEAD</span>
            </div>
            <div class="ts-lead-info">
              <app-user-template [user]="team?.teamLead" tooltipField="userData.status"></app-user-template>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════════════════
       MAIN DISPLAY - Statistics View
  ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="ts-main-display">
    <div class="container-fluid">
      
      <!-- Display Frame -->
      <div class="ts-display-frame" *ngIf="team">
        
        <!-- Scanline Effect Overlay -->
        <div class="ts-scanlines"></div>
        
        <!-- Content Area -->
        <div class="ts-display-content">
          
          <!-- Display Header -->
          <div class="ts-display-header">
            <fa-icon [icon]="faChartLine" class="ts-display-icon"></fa-icon>
            <span class="ts-display-title">PERFORMANCE METRICS</span>
            <div class="ts-display-line"></div>
          </div>

          <!-- Statistics Component -->
          <div class="ts-stats-container">
            <app-review-team-details-view [team]="team"></app-review-team-details-view>
          </div>

        </div>

      </div>

      <!-- Empty State -->
      <div class="ts-empty-state" *ngIf="!team">
        <div class="ts-empty-icon">
          <fa-icon [icon]="faGamepad"></fa-icon>
        </div>
        <div class="ts-empty-text">
          <span class="ts-empty-title">NO TEAM SELECTED</span>
          <span class="ts-empty-subtitle">Select a team from the control panel to view statistics</span>
        </div>
        <div class="ts-empty-animation">
          <div class="ts-pulse-ring"></div>
          <div class="ts-pulse-ring ts-pulse-ring--delay"></div>
        </div>
      </div>

    </div>
  </div>

</div>
